import React, {useContext} from 'react';
import {UserContext} from "../../../stores";
import {Modal} from "antd";
import {LoginRequestType} from "../../../constants";
import LoginCodeContent from "./LoginCodeContent";
import ChangePhoneNumberContent from "./ChangePhoneNumberContent";
import {BackButton} from "./styles";
import {faChevronLeft} from "@fortawesome/pro-light-svg-icons";
import {observer} from "mobx-react-lite";
import PropTypes from "prop-types";

function TwoFactorAuthModal({ visible }) {
  const userStore = useContext(UserContext);

  function onBackButtonClick() {
    userStore.setAttr('changingPhoneNumber', true);
  }

  function modalTitle() {
    // If the user is allowed to change his/her phone number then we will show a back button on the code page so the
    // user can change his phone number if entered incorrectly
    return !userStore.changingPhoneNumber && userStore.loginRequestType === LoginRequestType.CHANGE_PHONE_NUMBER ?
      <><BackButton icon={faChevronLeft} onClick={onBackButtonClick} />Two-Factor Authentication</> :
      "Two-Factor Authentication"
  }

  function onCancel() {
    // Reset all the properties of the loginRequest
    userStore.setAttr('loginRequestType', null);
    userStore.setAttr('changingPhoneNumber', false);
    userStore.setAttr('loginRequestAuthToken', null);
    userStore.setAttr('loginRequestErrorCode', "");
    userStore.setAttr('loginCodeTimeout', null);
  }

  return (
    (<Modal
      title={modalTitle()}
      centered
      open={visible}
      footer={null}
      onCancel={onCancel}
    >
      {userStore.changingPhoneNumber ? <ChangePhoneNumberContent /> : <LoginCodeContent />}
    </Modal>)
  );
}

TwoFactorAuthModal.propTypes = {
  visible: PropTypes.bool.isRequired,
}

export default observer(TwoFactorAuthModal);
